<template>
    <v-app>
        <v-toolbar fixed app :clipped-left="false" extended>
            <v-btn icon @click="$router.go(-1)">
                <v-icon class="icon-light">arrow_back</v-icon>
            </v-btn>
        </v-toolbar>
        <div id="header-image">
            <img :src="logo"/>
        </div>

        <v-content>
            <v-container fluid fill-height>
                <v-layout row full-width align-center justify-center>
                    <v-flex xs-12>
                        <v-text-field v-model="cellphone" type="number" label="Cellphone Number"></v-text-field>
                        <v-btn class="vas-btn" block @click="request">Send Password</v-btn>
                        <p class="description">Enter your cellphone number above, and we will SMS you your password.</p>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>

        <v-dialog v-model="showSuccessDialog" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Password Sent
                </v-card-title>

                <v-card-text>
                    We have sent you your password via SMS.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="$router.go(-1)">
                        Okay
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>
<script>
    import vas from "@/lib/VASClient"
    import {mapState} from 'vuex'

    export default {
        data() {
            return {
                cellphone: '',
                logo: require('../../../variants/' + BUILD_VARIANT + '/logo.png'),
                showSuccessDialog: false,
            }
        },
        methods: {
            request() {
                var self = this;
                Loading.show('');

                vas.requestPassword(this.cellphone).then(function (response) {
                    Loading.hide();

                    if (response.status) {
                        self.showSuccessDialog = true;
                    } else {
                        Snackbar.show('Invalid cellphone number provided');
                    }
                }).catch(function (response) {
                    Loading.hide();

                    Snackbar.show('An error occurred requesting your password. Please try again.');
                });
            }
        },
        computed: {
            ...mapState(
                ['auth']
            )
        },
        created() {

        }
    }
</script>